import { SEARCH_DETAIL_ENDPOINT } from 'constants/apis';
import { performPut } from 'services/rest-service/rest-service';

const executeRequestToShareSearch = async (groupsToShareWith, searchId) => {
  const sharingEndpoint = `${SEARCH_DETAIL_ENDPOINT}/${searchId}/share/{ACGId}?sharing={SHARE_LEVEL}`;
  const promises = groupsToShareWith.map(g => {
    return performPut(
      sharingEndpoint
        .replace('{ACGId}', g.id.toString())
        .replace('{SHARE_LEVEL}', g.sharingLevel),
    );
  });

  await Promise.all(promises);
};
export const checkIsSharedWithEveryone = accessControlGroups => {
  return accessControlGroups?.find(
    group => group.name?.toLowerCase() === 'everyone',
  );
};

export default executeRequestToShareSearch;
